export default {
  CONTROL_SOCKET_MODE_ERROR: 'CONTROL_SOCKET_MODE_ERROR',
};
